
<div class="mat-container">
<div mat-dialog-title>   </div>
<div mat-dialog-content style="text-align: center;">

  <form class="example-form">
    <mat-form-field class="example-full-width" appearance="fill">
      <mat-label>Edit Name</mat-label>
      <input matInput placeholder="Enter document name" value="Supporting Document 1">
    </mat-form-field>
  </form>
  <!-- You have reached the limit to add new realtors <br>To invite more realtors please upgrade your plan -->
</div>


<!-- <button type="button"  mat-flat-button>Clear</button> -->
<div mat-dialog-actions class="buttons">
  
<button mat-flat-button mat-dialog-close>Close</button>
    <button type="button" mat-flat-button mat-dialog-close  color="primary" (click)="gotoUpdatePlan()"> Save</button>
    <!-- <div>
    <button
    [disabled]="!((allowSave$ | async) && !!files.length) || customPreApprovalBtnFlag"
    (click)="save()"
    mat-flat-button
    color="primary">
    Save
  </button>
</div> -->
</div>




</div>
<!-- <button type="button" (click)="clear()" mat-flat-button>Clear</button>
    <button type="button" (click)="onSubmit()" mat-flat-button color="primary">Save</button> -->